
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18 18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.8525 12.8673L14.145 15.2373C14.22 15.8598 13.5525 16.2948 13.02 15.9723L9.87751 14.1048C9.53251 14.1048 9.19501 14.0823 8.86501 14.0373C9.42001 13.3848 9.75001 12.5598 9.75001 11.6673C9.75001 9.53726 7.90501 7.81229 5.62501 7.81229C4.75501 7.81229 3.95251 8.05977 3.28501 8.49477C3.26251 8.30727 3.255 8.11977 3.255 7.92477C3.255 4.51227 6.21751 1.74477 9.87751 1.74477C13.5375 1.74477 16.5 4.51227 16.5 7.92477C16.5 9.94977 15.4575 11.7423 13.8525 12.8673Z","stroke":"currentColor","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M9.75 11.6673C9.75 12.5598 9.42001 13.3848 8.86501 14.0373C8.12251 14.9373 6.945 15.5148 5.625 15.5148L3.6675 16.6773C3.3375 16.8798 2.9175 16.6023 2.9625 16.2198L3.15 14.7423C2.145 14.0448 1.5 12.9273 1.5 11.6673C1.5 10.3473 2.205 9.18477 3.285 8.49477C3.9525 8.05977 4.755 7.81229 5.625 7.81229C7.905 7.81229 9.75 9.53726 9.75 11.6673Z","stroke":"currentColor","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    